import { createFileRoute } from "@tanstack/react-router"
import { DeviceDetail } from "@/components/sensory"

export const Route = createFileRoute("/sensory/devices/$deviceNumber")({
  staticData: {
    title: 'Device Detail',
    isSecured: true,
  },
  component: DeviceDetailPage,
})

function DeviceDetailPage() {
  const { deviceNumber } = Route.useParams()

  return (
    <div className="p-6">
      <DeviceDetail deviceNumber={parseInt(deviceNumber)} />
    </div>
  )
}















